import { Link } from 'react-router-dom';
import { Link as LinkIcon, Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-frost-white flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center space-x-3 mb-8">
          <div className="w-10 h-10 bg-dark-slate rounded-xl flex items-center justify-center transform rotate-[15deg]">
            <LinkIcon className="w-6 h-6 text-mint-fresh" />
          </div>
          <span className="font-heading font-bold text-2xl text-dark-slate">GradLink</span>
        </div>

        <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-ambient">
          <div className="text-8xl font-heading font-extrabold text-slate-200 mb-4">404</div>
          <h1 className="font-heading font-bold text-2xl text-dark-slate mb-2">
            Page not found
          </h1>
          <p className="text-slate-gray mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="bg-dark-slate text-white rounded-full">
              <Link to="/dashboard">
                <Home className="w-4 h-4 mr-2" />
                Go to Dashboard
              </Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full">
              <Link to="/feed">
                <Search className="w-4 h-4 mr-2" />
                Browse Feed
              </Link>
            </Button>
          </div>
        </div>

        <div className="mt-6 space-y-2">
          <p className="text-sm text-slate-gray">Looking for something specific?</p>
          <div className="flex flex-wrap justify-center gap-2">
            {[
              { to: '/jobs', label: 'Jobs' },
              { to: '/events', label: 'Events' },
              { to: '/services', label: 'Services' },
              { to: '/chat', label: 'Chat' },
            ].map(link => (
              <Link key={link.to} to={link.to}
                className="px-3 py-1.5 rounded-full bg-white border border-slate-200 text-sm text-slate-gray hover:text-dark-slate hover:border-dark-slate transition-colors">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
